// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { UserOfficesInstance } from "./helpers/userOfficesInstanceHelpers";
import { createUserOfficesInstance } from "./helpers/userOfficesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, UserOfficesInstance>({
	name: "UserOffices",
	createBase: createBaseNotary,
	createInstance: createUserOfficesInstance,
});

export function getUserOfficesInstance(): UserOfficesInstance {
	return factory.getInstance();
}
